import { Injectable } from '@angular/core';
import HyperDX from '@hyperdx/browser';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class HyperDxService {

  constructor(private authService: AuthService) { }

  /**
   * Vincula o usuário logado ao HyperDX para identificação nos logs
   * Deve ser chamado após o login bem-sucedido
   */
  setUserIdentification(): void {
    try {
      const userId = this.authService.getUserId();
      const userName = this.authService.getUsername();
      const userEmail = this.getUserEmail(); // Tentaremos pegar do localStorage ou do contexto
      const permission = this.authService.getPermission();

      // Só configura se tivermos pelo menos o ID ou nome do usuário
      if (userId || userName) {
        HyperDX.setGlobalAttributes({
          userId: userId || 'unknown',
          userName: userName || 'Usuário não identificado',
          userEmail: userEmail || 'email_nao_disponivel@westetics.com.br',
          userPermission: permission || 'unknown',
          service: 'westetics-frontend',
          environment: 'production'
        });
      
      }
    } catch (error) {
      console.error('Erro ao configurar identificação do usuário no HyperDX:', error);
    }
  }

  /**
   * Remove a identificação do usuário do HyperDX (logout)
   */
  clearUserIdentification(): void {
    try {
      HyperDX.setGlobalAttributes({
        userId: 'anonymous',
        userName: 'Usuário Anônimo',
        userEmail: 'anonimo@westetics.com.br',
        userPermission: 'none',
        service: 'westetics-frontend',
        environment: 'production'
      });
      
    } catch (error) {
      console.error('Erro ao limpar identificação do usuário no HyperDX:', error);
    }
  }

  /**
   * Tenta obter o email do usuário do localStorage ou contexto
   */
  private getUserEmail(): string | null {
    try {
      // Usa o método do AuthService para obter o email
      const email = this.authService.getUserEmail();
      return email || null;
    } catch (error) {
      console.warn('Não foi possível obter o email do usuário:', error);
      return null;
    }
  }

  /**
   * Configura identificação temporária para pacientes preenchendo anamnese (não logados)
   */
  setPatientIdentification(patientName: string, patientEmail: string, anamneseId: string): void {
    try {
      HyperDX.setGlobalAttributes({
        userId: `patient-${anamneseId}`,
        userName: `Paciente: ${patientName}`,
        userEmail: `${patientName} <${patientEmail}>`, // Nome do paciente no campo email para aparecer na interface
        userPermission: 'patient-anamnese',
        patientName: patientName,
        patientEmail: patientEmail, // Email real do paciente em campo separado
        anamneseId: anamneseId,
        service: 'westetics-frontend',
        environment: 'production',
        userType: 'patient-filling-anamnese'
      });
      
    } catch (error) {
      console.error('Erro ao configurar identificação do paciente no HyperDX:', error);
    }
  }

  /**
   * Registra uma ação customizada no HyperDX
   */
  logAction(actionName: string, metadata?: any): void {
    try {
      // Começamos com os metadados fornecidos
      const actionData: any = {
        timestamp: new Date().toISOString(),
        ...metadata
      };

      // Se os metadados já contêm informações específicas de usuário/paciente, mantemos elas
      if (!metadata?.userId || !metadata?.userName) {
        // Só usa dados do AuthService se não há dados específicos nos metadados
        // ou se não é uma ação relacionada a paciente
        const hasPatientData = metadata?.patientName || metadata?.userType?.includes('patient');
        
        if (!hasPatientData) {
          actionData.userId = this.authService.getUserId();
          actionData.userName = this.authService.getUsername();
        }
      }

      HyperDX.addAction(actionName, actionData);
    } catch (error) {
      console.error('Erro ao registrar ação no HyperDX:', error);
    }
  }
} 